import { render } from "./UserPlusIcon.vue?vue&type=template&id=cc147ef0"
import script from "./UserPlusIcon.vue?vue&type=script&lang=js"
export * from "./UserPlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__